import React, { useEffect, useRef } from 'react';
import { CustomerCard, CustomersList, Layout } from '@components/customers';
import { Routes, Route, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { Container, media } from 'styled-bootstrap-grid';
import { useNavigation } from 'react-day-picker';
interface IProps {
    getCustomers: () => void;
}
const Customers = () => {
    const navigate = useNavigate();
    const _useRef = useRef<IProps>(null);
    const callCustomer = () => {
        if (_useRef?.current) {
            _useRef?.current?.getCustomers();
        }
    };
    var _userData = JSON.parse(localStorage.getItem('user') || '{}');
    useEffect(() => {
        if (_userData.user_login == 'customer') {
            navigate(`/customers/${_userData.user._id}`);
        }
    }, []);
    return (
        <Wrapper>
            {_userData.user_login == 'customer' ? '' : <CustomersList ref={_useRef} />}
            <Content>
                <Routes>
                    <Route path=":id" element={<CustomerCard callCustomer={callCustomer} />} />
                </Routes>
            </Content>
            <style>
                {`
                .customer-listing--main {
                    height: 100%;
                }
            `}
            </style>
        </Wrapper>
    );
};
const Wrapper = styled(Container)`
    padding: 0px;
    height: 100%;
    ${media.xs`
  display: block !important;
`}
    ${media.sm`
display: block !important;
`}
${media.md`
display: flex !important;
margin:0;
min-width:100%;
`}
${media.lg`
display: flex !important;
`}
`;
const Content = styled.div`
    flex: 1 1 0%;
`;
Customers.Layout = Layout;
export default Customers;
